var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{attrs:{"value":_vm.tjbForm[_vm.key],"true-label":"1","false-label":"0"},on:{"change":_vm.onChange}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }